module.exports = __webpack_public_path__ + "static/media/Combo_Pollo_Asado_Web.3fc1e0d3.png";